import commonPostTypeConfig from '../../common/postTypes/product'

export default function initPostType({ wapp }) {
    return wapp.client.postTypes.getPostType({
        name: 'product',
        addIfThereIsNot: true,
        statusManager: commonPostTypeConfig.getStatusManager()
    })
}
